import {Container, Row} from 'react-bootstrap'
import {useState, useEffect} from 'react'
import Axios from 'axios'
import Journal from './Journal'
import JournalEditModal from './JournalEditModal'

export default function JournalList(props) {

    const [journals, setJournals] = useState([])
    const [isEdit, setIsEdit] = useState(false);
    const [currentJournal, SetCurrentJournal] = useState("");
    const [modalShow, setModalShow] = useState(false);


    useEffect(() => {
        loadJournalList()
    }, [])

    const loadJournalList = () =>{
        Axios.get("journal/index", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }) 
        .then((response) => {
            console.log(response);
            setJournals(response.data.journals)
        })
        .catch((error) => {
            console.log(error)
        })
    }
    //const loadJournalList = (journal) => {
        // console.log(journal)
        // if(journal.notes)
        
        //Richard 20/7/22 commented line 36 and 37, replaced with line 35
        // const journal = journal.meditation.map((item, key) => (
       // if(journal.article){
           // const journal =  journal.article.map((item, key) => (
            
        //         <td key={key}>
        //         <li> {item.name} </li>
        //         </td>
        //     ));
        //  return journal;
        // }
    
    
    
    
    const editView = (id) => {
        Axios.get(`journal/edit?id=${id}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            props.handleSuccessMessage("Loaded Journal Information!")
            console.log(response.data.journal)
            var journal = response.data.journal
            setIsEdit(true)
            SetCurrentJournal(journal)
        })
        .catch(error => {
            props.handleErrorMessage("Error Loading Journal Information")
            console.log(error)
        })
    }
    
    const editJournal = (journal) => {
        Axios.put("journal/update", journal, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            props.handleSuccessMessage("Journal Information Updated")
            loadJournalList();
        })
        .catch(error => {
            props.handleErrorMessage("Error Editing Journal")
            console.log(error)
        })
    }
    
    
    const deleteJournal = (id) => {
        Axios.delete(`journal/delete?id=${id}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            props.handleSuccessMessage("Journal Deleted Successfully!")
            loadJournalList();
        })
        .catch(error => {
            console.log(error)
            props.handleErrorMessage("Error Deleting Journal!")
        })
    }
    

    
    const allJournals = journals.map((journal, index) => (
        <tr key={index}>
            <Journal {...journal} editView={editView} deleteJournal={deleteJournal} setModalShow={setModalShow} />
        </tr>
    ))

    
    return (
        <div>
            <h1>
                
                You have <span style={{ color:"#A70205" }}>{journals.length}</span> 
                
                {
                    journals.length === 1 ? " record " : " records "
                } 
                in your journal
            </h1>
            <Container>
            <Row xs={1} md={1} className="g-4">
                {allJournals}
            </Row>
            </Container>
            {
                <JournalEditModal currentJournal={currentJournal} key={currentJournal._id} journal={currentJournal} editJournal={editJournal} show={modalShow}
                onHide={() => setModalShow(false)}></JournalEditModal>
            }
           
        </div>
      )
        
} 

